import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AUTOMATION_TRIGGER_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_automation_trigger_datasets_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';

import { TriggerDatasets } from '@/types/datasets.ts';

const useRetrieveAutomationTriggerDatasets = (
  automationId?: string,
): UseQueryResult<TriggerDatasets, AxiosError> => {
  const apiClient = useApiClient();
  // const automationId = useAutomationId();

  return useQuery({
    queryKey: AUTOMATION_TRIGGER_DATASETS_KEY(automationId),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_trigger_datasets_url(automationId));
      return response.data;
    },
    enabled: !!automationId,
  });
};

export default useRetrieveAutomationTriggerDatasets;
